import { useEffect } from "react";
import NewWindow from "react-new-window";

interface Props {
  url?: string;
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  onOpen?: (window: Window) => void;
}
const PopoutWindow = ({
  url = "",
  isOpen = false,
  onClose,
  title = "",
  onOpen,
}: Props) => {
  useEffect(() => {
    if (isOpen) {
      localStorage.setItem("openerURL", window.location.href);
    } else {
      localStorage.removeItem("openerURL");
    }
    return () => {
      localStorage.removeItem("openerURL");
    };
  }, [isOpen]);

  return (
    isOpen && (
      <NewWindow
        url={url}
        title={title}
        features={{ width: 900, height: 700 }}
        center={"screen"}
        onUnload={onClose}
        copyStyles={false}
        onOpen={onOpen}
        // @ts-ignore -- Not in declarations file but is supported
        closeOnUnmount={true}
      />
    )
  );
};

export default PopoutWindow;
